import React from "react";
import { Button, Spinner } from "reactstrap";

interface SettingsButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  saveDisabled?: boolean;
  isSaving?: boolean;
}

const SettingsButtons: React.FC<SettingsButtonsProps> = ({
  onSave,
  onCancel,
  saveDisabled,
  isSaving
}) => {
  return (
    <div className="d-flex justify-content-end mt-4">
      <Button
        color="secondary"
        className="me-2"
        onClick={onCancel}
        disabled={isSaving}
      >
        Cancel
      </Button>
      <Button
        color="primary"
        onClick={onSave}
        disabled={saveDisabled || isSaving}
      >
        {isSaving ? (
          <>
            <Spinner size="sm" className="me-2" />
            Saving...
          </>
        ) : (
          'Save Changes'
        )}
      </Button>
    </div>
  );
};

export default SettingsButtons;